
import React, { useCallback } from "react";
import { useTranslation } from "react-i18next";
import { FormGroup, Label } from "reactstrap";
import { DropdownItem, FormFieldType } from "../types";

/**
 * Fetches data and maps id and name to select dropdown
 */
export const DropdownField = ({
    disableDefault, 
    items, 
    error, 
    className, 
    title, 
    input,
    ...props}:FormFieldType) => {
    const { t } = useTranslation();
    
    const renderOptions = useCallback(() => {
        if (items && typeof items[0] === 'object' && items[0] !== null ? true : false) {
            const objArr = items as DropdownItem[];

            return objArr?.map((v:DropdownItem) => <option key={v?.value}value={v?.value}>{t(v?.label || "")}</option>)
        }
        return items?.map((v) => <option key={v.toString()} label={v.toString()} value={v.toString()}>{v.toString()}</option>)
    }, [items]) // eslint-disable-line react-hooks/exhaustive-deps
    
    if (!items) return null;
    return  (
        <FormGroup>
            {title && <Label htmlFor={input.name}>{title}</Label>}
            <select 
                {...props}
                className={error ? `form-control error ${className}` : `form-control ${className}`}
                name={input.name}
                onChange={input.onChange}
                onBlur={input.onBlur}
                ref={input.ref}
                title={error && t(error.message || "This field is required")}>
                <option disabled={disableDefault === false ? false : true} value="">
                    {t("-")}
                </option>
                {renderOptions()}
            </select>
        </FormGroup>
    )
}